module.exports = "<svg viewBox=\"0 0 299.2 110.9\"><path d=\"M40.8 64.6C23 64.6 8.5 50.2 8.5 32.3S22.9 0 40.8 0s32.3 14.5 32.3 32.3c0 17.8-14.5 32.3-32.3 32.3zm0-45.7c-7.4 0-13.4 6-13.4 13.4s6 13.4 13.4 13.4 13.4-6 13.4-13.4S48.3 18.9 41 18.9h-.2z\" class=\"st0\"></path><path d=\"M81.6 110.9H62.7c0-12.1-9.8-21.9-21.9-21.9-12.1 0-21.9 9.8-21.9 21.9H0c-.4-22.5 17.6-41.1 40.2-41.4 22.5-.4 41.1 17.6 41.4 40.2v1.2z\" class=\"st0\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/icon-social-science.svg
// module id = 292
// module chunks = 1